import {
	lazy,
} from 'react'

export const RoomCreatePageAsync = lazy(async() => {
	return import('./room-create.page')
})
